module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top'), _vm._v(" "), _c('main', [_c('container', [_c('row', [_c('div', {
    staticClass: "col s12"
  }, [_c('h4', [_vm._v("Book List")]), _vm._v(" "), _c('div', {
    staticClass: "collection"
  }, _vm._l((_vm.lists), function(list) {
    return _c('a', {
      staticClass: "collection-item",
      attrs: {
        "download": _vm.getUrl(list.file),
        "href": _vm.getUrl(list.file)
      }
    }, [_vm._v("\n                            " + _vm._s(list.name) + "\n                        ")])
  }))])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79a9c120!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/page/BookList.vue
// module id = 81
// module chunks = 0